import { SubnavigationButton } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { useRef } from 'react';
import styles from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsListMobile.css';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface ScrollableTabItemProps {
    value: ETabsName;
    text: string;
    activeTariffTab?: ETabsName;
    onClick: () => void;
    marchPromo2026Enabled?: boolean;
}

export function ScrollableTabItem({ text, value, activeTariffTab, onClick, marchPromo2026Enabled }: ScrollableTabItemProps) {
    const ref = useRef<HTMLDivElement>(null);
    const selected = value === activeTariffTab;

    return (
        <SubnavigationButton
            getRootRef={ref}
            size="l"
            className={classNames(styles.scrollable_tabs_item, {
                [styles.scrollable_tabs_item_selected]: selected,
                [styles.scrollable_tabs_item_marchPromo2026]: marchPromo2026Enabled,
            })}
            value={value}
            selected={selected}
            onClick={() => {
                requestAnimationFrame(() => ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }));
                onClick();
            }}
        >
            {text}
        </SubnavigationButton>
    );
}
